(function () {
  const navRoot = document.querySelector('.pmd-navigation');
  if (!navRoot) return;

  const MOBILE_QUERY = '(max-width: 767px)';

  function parseToggle(value) {
    if (!value || !value.includes(':')) return null;
    const [selector, className] = value.split(':');
    return { target: document.querySelector(selector), className };
  }

  function isFocusableVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(isFocusableVisible);
  }

  function trapFocus(event, container) {
    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements(container);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setInert(el, inert) {
    if (!el) return;
    if (inert) el.setAttribute('inert', '');
    else el.removeAttribute('inert');
  }

  function getBackgroundInertTargets() {
    const targets = [document.getElementById('MainContent')];
    document.querySelectorAll('#MainContent ~ .shopify-section').forEach((section) => {
      targets.push(section);
    });
    return targets;
  }

  let mobileMenuReturnFocus = null;

  function syncInertState() {
    const menu = document.getElementById('pmd-mobile-nav');
    const search = document.getElementById('pmd-search');
    const isMobile = window.matchMedia(MOBILE_QUERY).matches;
    const menuOpen = isMobile && menu?.classList.contains('opened');
    const searchOpen = search?.classList.contains('opened');

    getBackgroundInertTargets().forEach((el) => setInert(el, menuOpen || searchOpen));

    const hamburger = document.getElementById('pmd-navigation-hamburger');
    const logo = navRoot.querySelector('.pmd-navigation-logo');
    const actions = navRoot.querySelector('.pmd-navigation-actions');

    if (menuOpen) {
      setInert(hamburger, true);
      setInert(logo, true);
      setInert(actions, true);
      setInert(search, true);
      setInert(menu, false);
      return;
    }

    if (searchOpen) {
      setInert(hamburger, true);
      setInert(logo, true);
      setInert(actions, true);
      setInert(menu, true);
      setInert(search, false);
      return;
    }

    [hamburger, logo, actions, search, menu].forEach((el) => setInert(el, false));
  }

  function syncMobileMenuFocus(previousOpen) {
    const menu = document.getElementById('pmd-mobile-nav');
    const hamburger = document.getElementById('pmd-navigation-hamburger');
    if (!menu || !window.matchMedia(MOBILE_QUERY).matches) return;

    const isOpen = menu.classList.contains('opened');

    if (isOpen && !previousOpen) {
      mobileMenuReturnFocus = hamburger;
      requestAnimationFrame(() => {
        getFocusableElements(menu)[0]?.focus();
      });
      return;
    }

    if (!isOpen && previousOpen && mobileMenuReturnFocus) {
      mobileMenuReturnFocus.focus();
      mobileMenuReturnFocus = null;
    }
  }

  function closeSiblingSubmenus(target) {
    if (target.classList.contains('pmd-root-link-submenu')) {
      navRoot.querySelectorAll('.pmd-root-link-submenu.opened').forEach((submenu) => {
        if (submenu !== target) submenu.classList.remove('opened');
      });
      return;
    }

    if (target.classList.contains('pmd-link-submenu')) {
      const list = target.closest('.pmd-root-link-submenu-list');
      list?.querySelectorAll('.pmd-link-submenu.opened').forEach((submenu) => {
        if (submenu !== target) submenu.classList.remove('opened');
      });
    }
  }

  function toggleTarget(trigger) {
    const parsed = parseToggle(trigger.dataset.toggleFor);
    if (!parsed?.target || !parsed.className) return;

    const willOpen = !parsed.target.classList.contains(parsed.className);
    if (willOpen) closeSiblingSubmenus(parsed.target);

    parsed.target.classList.toggle(parsed.className);
    initToggleAria();

    if (willOpen && document.activeElement === trigger) {
      const focusable = getFocusableElements(parsed.target)[0];
      if (focusable) requestAnimationFrame(() => focusable.focus());
    }
  }

  function syncToggleState(trigger) {
    const parsed = parseToggle(trigger.dataset.toggleFor);
    if (!parsed?.target) return;

    const expanded = parsed.target.classList.contains(parsed.className);
    if (trigger.hasAttribute('aria-expanded')) {
      trigger.setAttribute('aria-expanded', String(expanded));
    }
    if (parsed.target.hasAttribute('aria-hidden')) {
      parsed.target.setAttribute('aria-hidden', String(!expanded));
    }
  }

  function syncMobileNav() {
    const menu = document.getElementById('pmd-mobile-nav');
    const hamburger = document.getElementById('pmd-navigation-hamburger');
    if (!menu) return;

    const isMobile = window.matchMedia(MOBILE_QUERY).matches;
    if (isMobile) {
      const open = menu.classList.contains('opened');
      menu.setAttribute('aria-hidden', String(!open));
      hamburger?.setAttribute('aria-expanded', String(open));
    } else {
      menu.removeAttribute('aria-hidden');
      hamburger?.setAttribute('aria-expanded', 'false');
    }
  }

  function syncSearchPanel() {
    const search = document.getElementById('pmd-search');
    const trigger = navRoot.querySelector('[aria-controls="pmd-search"]');
    if (!search) return;

    const open = search.classList.contains('opened');
    search.setAttribute('aria-hidden', String(!open));
    trigger?.setAttribute('aria-expanded', String(open));
  }

  function syncSubmenus() {
    navRoot.querySelectorAll('.pmd-root-link-submenu, .pmd-link-submenu').forEach((submenu) => {
      const isMobile = window.matchMedia(MOBILE_QUERY).matches;
      const open = submenu.classList.contains('opened');
      if (isMobile) {
        submenu.setAttribute('aria-hidden', String(!open));
        return;
      }
      const block = submenu.closest('.shopify-block');
      const hovered = block?.matches(':hover');
      submenu.setAttribute('aria-hidden', String(!open && !hovered));
    });
  }

  function initDesktopSubmenuHover() {
    navRoot.querySelectorAll('.shopify-block:has(.pmd-root-link-submenu)').forEach((block) => {
      block.addEventListener('mouseenter', syncSubmenus);
      block.addEventListener('mouseleave', syncSubmenus);
    });
  }

  function initToggleAria() {
    navRoot.querySelectorAll('[data-toggle-for]').forEach((trigger) => {
      syncToggleState(trigger);
    });
    syncMobileNav();
    syncSearchPanel();
    syncSubmenus();
    syncInertState();
  }

  navRoot.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const trigger = event.target.closest(
        '.pmd-root-link[data-toggle-for], .pmd-nav-sub-link-image[data-toggle-for]'
      );
      if (!trigger || !navRoot.contains(trigger)) return;

      event.preventDefault();
      toggleTarget(trigger);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('.pmd-navigation [data-toggle-for]');
      if (!trigger) return;

      if (trigger.tagName === 'A') {
        const href = trigger.getAttribute('href');
        if (!href || href === '#') event.preventDefault();
      }

      requestAnimationFrame(() => {
        initToggleAria();
      });
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    let shouldSync = false;
    mutations.forEach((mutation) => {
      if (mutation.attributeName !== 'class') return;

      shouldSync = true;

      if (mutation.target.id === 'pmd-mobile-nav') {
        const previousOpen = (mutation.oldValue || '').split(/\s+/).includes('opened');
        syncMobileMenuFocus(previousOpen);
      }
    });
    if (shouldSync) initToggleAria();
  });

  navRoot
    .querySelectorAll(
      '#pmd-mobile-nav, #pmd-search, .pmd-root-link-submenu, .pmd-link-submenu'
    )
    .forEach((element) => {
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      });
    });

  window.addEventListener('resize', initToggleAria);

  document.addEventListener('keydown', (event) => {
    const menu = document.getElementById('pmd-mobile-nav');
    if (
      menu?.classList.contains('opened') &&
      window.matchMedia(MOBILE_QUERY).matches &&
      navRoot.contains(menu)
    ) {
      trapFocus(event, menu);
    }

    const search = document.getElementById('pmd-search');
    if (search?.classList.contains('opened')) {
      trapFocus(event, search);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openLinkSubmenu = navRoot.querySelector('.pmd-link-submenu.opened');
    if (openLinkSubmenu) {
      openLinkSubmenu.classList.remove('opened');
      navRoot.querySelector(`[aria-controls="${openLinkSubmenu.id}"]`)?.focus();
      initToggleAria();
      return;
    }

    const openRootSubmenu = navRoot.querySelector('.pmd-root-link-submenu.opened');
    if (openRootSubmenu) {
      openRootSubmenu.classList.remove('opened');
      navRoot.querySelector(`[aria-controls="${openRootSubmenu.id}"]`)?.focus();
      initToggleAria();
      return;
    }

    const search = document.getElementById('pmd-search');
    if (search?.classList.contains('opened')) {
      search.classList.remove('opened');
      search.classList.add('closed');
      initToggleAria();
      navRoot.querySelector('[aria-controls="pmd-search"]')?.focus();
      return;
    }

    const menu = document.getElementById('pmd-mobile-nav');
    if (menu?.classList.contains('opened')) {
      menu.classList.remove('opened');
      initToggleAria();
      document.getElementById('pmd-navigation-hamburger')?.focus();
    }
  });

  window.focusInput = function focusInput() {
    requestAnimationFrame(() => {
      document.getElementById('pmd-search-input')?.focus();
    });
  };

  const input = document.getElementById('pmd-search-input');
  const container = document.getElementById('search-container');
  const searchPanel = document.getElementById('pmd-search');

  function fetchResults(query) {
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'query,product',
      'resources[limit]': '5',
      section_id: 'api-predictive-search',
    });

    fetch(`/search/suggest?${params.toString()}`)
      .then((resp) => resp.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const extracted = doc.querySelector('#shopify-section-api-predictive-search');
        if (container) {
          container.innerHTML = extracted
            ? extracted.innerHTML
            : '<p role="status">No results found.</p>';
        }
      });
  }

  if (input && searchPanel) {
    input.addEventListener('focus', () => {
      searchPanel.classList.remove('closed');
      searchPanel.classList.add('opened');
      initToggleAria();
    });

    let debounceTimer;
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const query = input.value.trim();
        if (query.length >= 2) fetchResults(query);
        else if (container) container.innerHTML = '';
      }, 300);
    });
  }

  navRoot.querySelector('[data-pmd-overlay]')?.addEventListener('click', () => {
    const menu = document.getElementById('pmd-mobile-nav');
    const search = document.getElementById('pmd-search');

    if (menu?.classList.contains('opened') && window.matchMedia(MOBILE_QUERY).matches) {
      menu.classList.remove('opened');
      initToggleAria();
      return;
    }

    if (search?.classList.contains('opened')) {
      search.classList.remove('opened');
      search.classList.add('closed');
      if (input) input.value = '';
      if (container) container.innerHTML = '';
      initToggleAria();
      navRoot.querySelector('[aria-controls="pmd-search"]')?.focus();
    }
  });

  navRoot.querySelector('[data-pmd-search-close]')?.addEventListener('click', () => {
    searchPanel?.classList.add('closed');
    searchPanel?.classList.remove('opened');
    if (input) input.value = '';
    if (container) container.innerHTML = '';
    initToggleAria();
    navRoot.querySelector('[aria-controls="pmd-search"]')?.focus();
  });

  document.addEventListener('click', (event) => {
    if (event.target.id === 'predictiveSearchActionViewAllResults' && input) {
      window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}`;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !input || !searchPanel) return;
    if (!searchPanel.classList.contains('opened')) return;
    if (document.activeElement !== input) return;
    window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}`;
  });

  initDesktopSubmenuHover();
  initToggleAria();
})();

